import { mapKeys } from 'lodash';
import { StoryType } from '../models/story-type.enum';
import { storyType } from '../state/story-type';

function moduleNameFromStoryId(storyId: string) {
  return storyType(storyId) === StoryType.Bookmark
    ? storyId
    : storyId.split('/').pop();
}

export function mergeReflections(
  currentReflections,
  newReflections,
  currentStoryId: string,
  newStoryId: string
) {
  currentReflections = currentReflections || {};
  newReflections = newReflections || {};

  // if the current id already has a namespace, return it.
  // otherwise, namespace as normal
  const namespaceReflectionId = (storyId, currentId) => {
    const isAlreadyNamespaced = id => id.includes('/');
    return isAlreadyNamespaced(currentId)
      ? currentId
      : `${moduleNameFromStoryId(storyId)}/${currentId}`;
  };

  return {
    ...mapKeys(currentReflections, (value, key) =>
      namespaceReflectionId(currentStoryId, key)
    ),
    ...mapKeys(newReflections, (value, key) =>
      namespaceReflectionId(newStoryId, key)
    )
  };
}
